// eslint-disable react/jsx-handler-names
import React from 'react';
// import Sidebar from '../components/Sidebar/Sidebar';
import TopNav, {
  Interactions,
  LogoText,
  NotificationsAction,
  HelpAction,
  ProfileAction,
} from '@hig/top-nav';
import Button from '@hig/button';

export const withTopNavLayout = (Wrapped) => (props) => {
  return (
    <>
      <div className="topnav">
        <TopNav
          logo={<LogoText>Autodesk Forge API</LogoText>}
          rightActions={
            <Interactions>
              <NotificationsAction />
              <HelpAction />
              <ProfileAction avatarName={props.userName} avatarImage={props.userImage}>
                <div className="profile">
                  <p className="name">{props.userName}</p>
                  <p className="email">{props.userEmail}</p>
                  <p className="userId">{props.userId}</p>
                  <Button
                    size="standard"
                    title="Logout"
                    type="primary"
                    onClick={props._handleLogout}
                  />
                </div>
              </ProfileAction>
            </Interactions>
          }
        />
      </div>
      <Wrapped {...props} />
    </>
  );
};

export default withTopNavLayout;
